import { logger } from "./logger"

export const useLogger = () => logger
